module.exports = __webpack_public_path__ + "img/GB.a5ebe2df.svg";